import React, { Component } from 'react';
import { Menu, Icon, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import {
  MENU_OPTION_CYCLE_MENU,
  MENU_OPTION_CALENDAR,
  MENU_OPTION_LIST_MENUS,
  MENU_OPTION_TEMPLATE_MENUS,
  NEW_MODIFIER,
  MENU_OPTION_APPLIED_MENUS,
} from '../helpers/Constants';
import { DirtyWrapper } from 'Components/';

class MenusNavMenu extends Component {
  iconItems = [
    {
      name: MENU_OPTION_CYCLE_MENU,
      icon: 'refresh',
      text: 'Cycle Menus',
    },
    {
      name: MENU_OPTION_APPLIED_MENUS,
      icon: 'window restore',
      text: 'Applied Menus',
    },
    {
      name: MENU_OPTION_CALENDAR,
      icon: 'calendar outline',
      text: 'Calendar Menus',
    },
    {
      name: MENU_OPTION_LIST_MENUS,
      icon: 'list',
      text: 'List Menus',
    },
    {
      name: MENU_OPTION_TEMPLATE_MENUS,
      icon: 'file alternate outline',
      text: 'Template Menus',
    },
  ];

  confirmChange = name => {
    this.props.onMenuChange(name);
    this.props.resetDirty();
  };

  // Used to prevent dirty prompt when changing date filters for the
  // applied menu date range.
  get shouldDisableDirtyPrompt() {
    const { activeItem } = this.props;

    switch (activeItem) {
      case MENU_OPTION_APPLIED_MENUS:
        return true;
      default:
        return false;
    }
  }

  renderItems = () => {
    return this.iconItems.map((item, index) => {
      return (
        <DirtyWrapper
          closeModalYesCallback={() => this.confirmChange(item.name)}
          key={index}
          isReadOnly={this.shouldDisableDirtyPrompt}
        >
          {showDirtyConfirm => (
            <Menu.Item
              name={item.name}
              active={
                this.props.activeItem === item.name ||
                this.props.activeItem === item.name + NEW_MODIFIER
              }
              className="mnm-icon-item"
              onClick={showDirtyConfirm}
            >
              <Grid textAlign="center">
                <Grid.Row>
                  <Grid.Column className="mnm-icon-text">
                    {item.text}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="mnm-icon-column">
                    <Icon name={item.icon} size="huge" />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Menu.Item>
          )}
        </DirtyWrapper>
      );
    });
  };

  render() {
    const menuItems = this.renderItems();
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <Menu
              size="tiny"
              className="menus-nav-menu"
              widths={menuItems.length}
            >
              {menuItems}
            </Menu>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

MenusNavMenu.propTypes = {
  activeItem: PropTypes.string.isRequired,
  onMenuChange: PropTypes.func.isRequired,
  resetDirty: PropTypes.func.isRequired,
};

export { MenusNavMenu };



// WEBPACK FOOTER //
// ./src/pages/managemenu/components/MenusNavMenu.js